<template>
    <page>
        <module title="搭配套餐详情">
            <div v-if="bundleInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="套餐名称">{{ bundleInfo.bundleName }}</c-detail-item>
                    <c-detail-item label="套餐价格">￥{{ parseFloat(bundleInfo.bundlePrice).toFixed(2) }}</c-detail-item>
                    <c-detail-item label="套餐描述">{{ bundleInfo.bundleDesc }}</c-detail-item>
                    <c-detail-item label="状态">
                        <span v-if="bundleInfo.state === 1" style="color:green">启用</span>
                        <span v-else style="color:red">禁用</span>
                    </c-detail-item>
                    <c-detail-item label="可售范围" full>{{bundleInfo.visible_user_level_name}}</c-detail-item>

                    <c-detail-item label="创建人">{{ bundleInfo.createUserName }}</c-detail-item>
                    <c-detail-item label="创建时间">{{ bundleInfo.createDate }}</c-detail-item>
                </c-detail>

                <c-detail title="套餐商品">
                    <c-table v-model="productList" height="auto" border>
                        <c-table-column label="商品信息" name="productName" width="250">
                            <template v-slot="{data}">
                                <product-info
                                        :image="data.productImgUrl"
                                        :name="`${data.productName}`">
                                </product-info>
                            </template>
                        </c-table-column>
                        <c-table-column label="商品价格" name="productPrice" width="100">
                            <template v-slot="{data}">￥{{ data.productPrice }}</template>
                        </c-table-column>
                        <c-table-column label="商品状态" name="state" width="100">
                            <template v-slot="{data}">
                                <span v-if="data.state == 0" style="color:red">{{dict.productState[data.state]}}</span>
                                <span v-if="data.state == 1" style="color:#999999">{{dict.productState[data.state]}}</span>
                                <span v-if="data.state == 2" style="color:green">{{dict.productState[data.state]}}</span>
                                <span v-if="data.state == 3" style="color:blue">{{dict.productState[data.state]}}</span>
                                <span v-if="data.state == 4" style="color:red">{{dict.productState[data.state]}}</span>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-detail>
                <c-detail title="套餐等级价格">
                    <c-detail-item label="套餐价格">￥{{ parseFloat(bundleInfo.bundlePrice).toFixed(2) }}</c-detail-item>
                    <c-table v-model="bundleInfo.levelPrices" height="auto" border style="margin-top: 20px;">
                        <c-table-column label="等级名称" name="levelName" width="30">
                        </c-table-column>
                        <c-table-column label="等级价格" name="bundlePrice" width="100">
                            <template v-slot="{data}">
                                ￥{{ parseFloat(data.bundlePrice).toFixed(2)}}
                            </template>
                        </c-table-column>
                    </c-table>
                </c-detail>
            </div>
            <template slot="button">
                <c-button size="m" @click="closeCurrPage()">关闭</c-button>
            </template>
        </module>
    </page>
</template>

<script>
import productInfo from '@/components/public/product_info.vue';
import {mapState} from "vuex";

export default {
    name: 'bundle_detail',

    components: {
        productInfo
    },

    props: {
        id: String
    },

    data() {
        return {
            bundleInfo: null,
            productList: []
        };
    },

    computed: {
        ...mapState(['dict']),
        ...mapState(['systemConfig'])
    },

    watch: {
        id() {
            this.getBundleDetail();
        }
    },

    mounted() {
        this.getBundleDetail();
    },

    methods: {
        getBundleDetail() {
            this.request({
                url: '/bundle/detail',
                data: { id: this.id },
                loading: true,
                success: data => {
                    this.bundleInfo = data;
                    this.productList = data.products;
                }
            });
        },
        closeCurrPage() {
            this.redirectTo('/bundle');
        }
    }
};
</script>
